import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import C from "./components/deliveryMethodSelect.ce.vue.js";
import { vCopyVueucStylesToShadowDom as g } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { useLanguage as v } from "../../utils/useLanguage.js";
import { defineComponent as S, watch as M, withDirectives as O, openBlock as V, createBlock as _, withCtx as D, createVNode as w } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as B } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { ref as R, unref as o } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import x from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import N from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
const U = /* @__PURE__ */ S({
  __name: "index.ce",
  props: {
    deliveryModel: { type: String },
    list: { default: () => [], type: Array },
    id: { default: "", type: String },
    disabled: { type: Boolean },
    orderType: { default: "LSD", type: String },
    destinationRegion: { default: "", type: String },
    isAll: { type: Boolean, default: !1 },
    isClassify: { type: Boolean, default: !1 },
    optionEmptyHidden: { type: Boolean },
    locale: { default: "zh-CN", type: null }
  },
  emits: ["update:modelValue", "change", "returnOptions", "onChangeDeliveryMethod"],
  setup(i, { expose: d, emit: p }) {
    const r = B(), { i18n: s } = v(), a = i;
    M(
      () => a.locale,
      (e) => {
        s.global.locale.value = e || "zh-CN";
      },
      {
        immediate: !0
      }
    );
    const l = p, u = (e) => {
      l("update:modelValue", e);
    }, m = (e) => {
      l("change", e);
    }, c = (e) => {
      l("returnOptions", e);
    }, y = (e, n, h) => {
      l("onChangeDeliveryMethod", e, n, h);
    }, f = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, t = R(null);
    return d({
      // 通过 ref 获取子组件暴露的 selectOptions
      getSelectOptions: () => {
        var e;
        return (e = t.value) == null ? void 0 : e.selectOptions;
      },
      // 通过 ref 获取子组件暴露的 selected 值
      getSelectedValue: () => {
        var e;
        return (e = t.value) == null ? void 0 : e.selected;
      },
      deliveryMethodSelectRef: t,
      setSelectedValue: (e) => {
        t.value && t.value.setSelected(e);
      }
    }), (e, n) => O((V(), _(o(N), {
      locale: o(x),
      "theme-overrides": f,
      "style-mount-target": o(r)
    }, {
      default: D(() => [
        w(C, {
          ref_key: "deliveryMethodSelectRef",
          ref: t,
          parameter: a,
          "onUpdate:modelValue": u,
          onChange: m,
          onOnChangeDeliveryMethod: y,
          onReturnOptions: c
        }, null, 512)
      ]),
      _: 1
    }, 8, ["locale", "style-mount-target"])), [
      [o(g), o(r)]
    ]);
  }
});
export {
  U as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/delivery-method/index.ce.vue2.js
// module id = 1279
// module chunks = 67